import type { TFunction } from "i18next";

// Returns a humanized "checked Xh ago" string using i18next so the noun form
// follows the active locale's plural rules. Returns null when the input is
// missing or in the future.
export function lastCheckedLabel(
  iso: string | null | undefined,
  t: TFunction,
  now: number = Date.now(),
): string | null {
  if (!iso) return null;
  const ts = new Date(iso).getTime();
  if (!Number.isFinite(ts)) return null;

  const diffMs = now - ts;
  if (diffMs < 0) return null;

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 5) return t("game_detail.shop_checked_just_now");
  if (minutes < 60) return t("game_detail.shop_checked_minutes_ago", { count: minutes });

  const hours = Math.floor(diffMs / 3_600_000);
  if (hours < 24) return t("game_detail.shop_checked_hours_ago", { count: hours });

  const days = Math.floor(diffMs / 86_400_000);
  return t("game_detail.shop_checked_days_ago", { count: days });
}
